import { render, staticRenderFns } from "./StandardAct.vue?vue&type=template&id=a680e616"
import script from "./StandardAct.vue?vue&type=script&lang=js"
export * from "./StandardAct.vue?vue&type=script&lang=js"
import style0 from "./StandardAct.vue?vue&type=style&index=0&id=a680e616&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports